import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';

import * as symbols from '../../operations/symbols';
import * as actions from "../../actions/ordersAction";
import { ORDER_STATUS } from './../../operations/constants'
import './orders.scss';
import DirectionLine from 'sushiweb/Icons/all/DirectionLine';

class OrderCardComponent extends Component {

  constructor(props) {
    super(props);
    this.state = {}
  }

  getVerifiedBtn(status) {
    let statusTitle = "";
    let className = "";
    switch (status) {
      case ORDER_STATUS.delivered:
        statusTitle = "Delivered";
        className = "btn btn-info btn-sm nohover";
        break;
      case ORDER_STATUS.cancelled:
        statusTitle = "Cancelled";
        className = "btn btn-red-smoke btn-sm nohover";
        break;
      case ORDER_STATUS.pending:
        statusTitle = "Pending";
        className = "btn btn-gray btn-sm nohover";
        break;
      case ORDER_STATUS.reattempt:
        statusTitle = "Re-Attempt"
        className = "btn btn-yellow btn-sm nohover";
        break;
      default:
        break;
    }
    return (
      <div className="order-value">
        <div className={className}>
          {statusTitle}
        </div>
      </div>
    )
  }

  getPhoneNumber(phones) {
    if (phones.length > 0) {
      return phones[0].phoneNumber
    } else {
      return "-"
    }
  }

  sendToDetail(id) {
    this.props.history.push('/order/' + id)
  }

  showDirections = () => {
    const { order } = this.props;
    const { outletLatitude, outletLongitude } = order;
    window.location.href = `https://www.google.com/maps/search/?api=1&query=${outletLatitude},${outletLongitude}`;
  }

  render() {
    const { order } = this.props;
    const { outletLatitude, outletLongitude } = order;
    return (
      <div className="order-card mt-1 mb-1">
        <div className="order-title">
          <div className="row">
            <div className="col-xs-6">
              <div className="subtitle fs-15">
                Order - <span className="okra-med">{order.orderNumber}</span>
              </div>
            </div>

            <div className="col-xs-3 align-right">
              <div className="value">
                {order.on_priority ?
                   <div className="order-value">
                   <div className="btn btn-red btn-sm nohover">
                     Priority
                   </div>
                 </div> : <div></div>
                }
              </div>
            </div>
            
            <div className="col-xs-3 align-right">
              <div className="value">
                {
                  this.getVerifiedBtn(order.status)
                }
              </div>
            </div>
           
          </div>
        </div>
        <div className="light-line"></div>
        <div className="orders-body">
          {
            order.is_cod &&
            <div className="cod">
              CASH ON DELIVERY
            </div>
          }
          <div className="row">
            <div className="col-xs-6">
              <div className="mt-1 subtitle">
                Outlet
                </div>
              <div className=" value">
                {order.outletName}
              </div>
            </div>
            <div className="col-xs-6">
              <div className="mt-1 subtitle">
                Phone
                    </div>
              <div className=" value">
                <a href={`tel:${this.getPhoneNumber(order.phones)}`}>
                <React.Fragment><FontAwesomeIcon icon="phone" className="blue-text mr-05" /><span className="blue-text">{this.getPhoneNumber(order.phones)}</span></React.Fragment>                 
                </a>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <div className="mt-1 subtitle">
                Address
                </div>
              <div className=" value">
                {order.outletAddress}
              </div>
            </div>
            <div className="col-xs-6">
            { outletLatitude !== 0  && outletLongitude !==0 &&
            <div className="mt-2 flex fs-16 blue-text w-600" onClick={() => this.showDirections()}>
              <DirectionLine className="get-direction"/> &nbsp; Location
            </div>
            }
            </div>
          </div>
          <div className="row">
            <div className="col-xs-6">
              <div className="mt-1 subtitle">
                Delivery Slot
                    </div>
              <div className=" value">
                <div className="mt-1 value">
                  {order.slotTime === '' ? '-' : order.slotTime}
                </div>
              </div>
            </div>
            <div className="col-xs-6">
              <div className="mt-1 subtitle">
                Invoice count
                    </div>
              <div className=" value">
                <div className="mt-1 value">
                  {order.invoice_count === '' ? '-' : order.invoice_count}
                </div>
              </div>
              
            </div>
            <div className="col-xs-6">
              <div className="mt-1 subtitle">
                Priority Order
                    </div>
              <div className=" value">
                <div className="mt-1 value">
                  {order.on_priority? "Yes":"No"}
                </div>
              </div>
              
            </div>
          </div>
          {
            !order.fetchedStatus ?
              <div className="btn btn-expand btn-transparent mt-2">
                Updating order details...
                </div>
              :

              <React.Fragment>
                {
                  !(order.status === ORDER_STATUS.cancelled) ?
                    <React.Fragment>
                      {
                        order.status !== ORDER_STATUS.delivered ?
                          <React.Fragment>
                            <div className="btn btn-expand btn-green mt-2"
                              onClick={(id) => this.sendToDetail(order.orderId)}>
                              {order.status === ORDER_STATUS.pending ? 'Start Delivery' : 'Re-Attempt Delivery'}
                            </div>
                            {
                              <div className="btn btn-expand btn-transparent mt-1"
                                onClick={(id) => this.props.openReasonListModal(order.orderId)}>
                                Can't Deliver
                              </div>
                            }
                          </React.Fragment>
                          :
                          <div className="btn btn-expand btn-transparent-green btn-normal mt-2"
                            onClick={(id) => this.sendToDetail(order.orderId)}>
                            View details
                          </div>
                      }
                    </React.Fragment>
                    : null
                }
              </React.Fragment>
          }
        </div>
      </div>
    )
  }
}

export default withRouter(connect(
  state => ({
    user: state.auth.user
  }),
  dispatch => ({
    actions: bindActionCreators(actions, dispatch),
  }),
)(OrderCardComponent));
